import React, { Component } from 'react';

class Notification extends Component {
  render() {
    const notifications = [
      { id: 1, title: 'Booking Confirmed', time: '2 hours ago', detail: 'Your reservation for Private AC Bedroom was approved.' },
      { id: 2, title: 'Security Alert', time: '1 day ago', detail: 'New login detected from Dhaka, Bangladesh.' }
    ];

    return (
      <div className="notifications-view">
        <h2 style={{ marginBottom: '24px' }}>Notifications</h2>
        <div>
          {notifications.map((notif) => (
            <div key={notif.id} style={{
              padding: '16px',
              border: '1px solid var(--border)',
              borderRadius: '12px',
              marginBottom: '12px',
              backgroundColor: 'var(--bg-card)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <strong>{notif.title}</strong>
                <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{notif.time}</span>
              </div>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-muted)' }}>{notif.detail}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Notification;